// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2X8qc","location":"Header_location__3KZFL"};